<template>
  <div class="white">
    <v-app-bar :color="darkMode ? 'background' : 'background'" app flat class=" my-4 mx-3 px-1 rounded-t-xl">
      <v-avatar
        size="30px"
        class="secondary mr-3"
        style=" webkit-box-shadow: 3px 3px 5px 2px #d5d0e4;"
        v-if="$vuetify.breakpoint.smAndDown"
      >
        <v-app-bar-nav-icon
          :color="darkMode ? 'white' : 'white'"
          @click.stop="$store.commit('main/lToggle')"
        ></v-app-bar-nav-icon>
      </v-avatar>
      <div :class="darkMode ? 'white--text' : 'primary--text'">
        {{ moduleName | toTitleCase }}
      </div>
      <v-spacer></v-spacer>

      <a>
        <v-avatar
          @click.stop="$store.commit('main/rToggle')"
          :size="37"
          color="white"
          style=" webkit-box-shadow: 3px 3px 5px 2px #d5d0e4;"
        >
          <img v-if="user.image" :src="user.image.url.logo" alt="avatar" />
          <img v-else src="img/avatar-l.png" alt="avatar" />
        </v-avatar>
      </a>
    </v-app-bar>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      sidebar: false,
      avatar: null,
      menu: false,
      loading: false,
    }
  },
}
</script>
